import React from "react";
import AsyncApiComponent from "@kyma-project/asyncapi-react";

import { AvalonAsync } from "../async_avalon";
import "@kyma-project/asyncapi-react/lib/styles/fiori.css";
import "./../style.css";

const AsyncAPIForAvalon = () => {
	return(
		<AsyncApiComponent schema={AvalonAsync} />
	)
}

export default AsyncAPIForAvalon;